import { injectable } from "inversify";
import { IPesquisaNpsGateway } from "./IPesquisaNpsGateway";
import "reflect-metadata";
import { IParamsObterPesquisaNps } from "./type";

@injectable()
export default class PesquisaFakeNpsGateway implements IPesquisaNpsGateway {
  private exibir = true;
  private tipoCampanha = 1;

  async handleSalvarNps(): Promise<boolean> {
    return true;
  }

  async handleSalvarContatoNps(): Promise<boolean> {
    return true;
  }

  async handleObterDadosPesquisa(): Promise<IParamsObterPesquisaNps[] | []> {
    return [
      {
        cliente: "Teste",
        tipoCampanha: this.tipoCampanha,
        exibirCampanha: this.exibir,
        campanhaId: "abcde123456"
      },
      {
        cliente: "Teste",
        tipoCampanha: this.tipoCampanha,
        exibirCampanha: this.exibir,
        campanhaId: "abcde123456"
      }
    ];
  }

  setMockData(exibir: boolean, tipoCampanha: number): void {
    this.exibir = exibir;
    this.tipoCampanha = tipoCampanha;
  }
}
